// Turns the raw message a payment page got from the API (or a thrown error) into one of the client-facing states.
const COPY = {
    expired: { title: 'This Payment Link Has Expired', message: 'For your security, payment links are only valid for a limited time.', hint: 'Please contact your travel agent and they will send you a new link.' },
    cancelled: { title: 'This Payment Link Was Cancelled', message: 'Your travel agent has cancelled this payment request.', hint: 'If you think this is a mistake, please reach out to your travel agent.' },
    completed: { title: 'Payment Already Received', message: 'This payment has already been completed, so there is nothing more you need to do.', hint: 'If you need a receipt or have a question, please contact your travel agent.' },
    'not-found': { title: "We Couldn't Find This Payment Link", message: 'The link may be incorrect or no longer valid.', hint: 'Please check the link in your email, or contact your travel agent.' },
    error: { title: 'Something Went Wrong', message: "We couldn't load this page right now.", hint: 'Please try again in a moment, or contact your travel agent.' }
};

export function classifyPaymentMessage(message) {
    const text = String(message || '').toLowerCase();
    if (/expired/.test(text)) return 'expired';
    if (/cancel/.test(text)) return 'cancelled';
    if (/not found|no longer valid|invalid|does not exist/.test(text)) return 'not-found';
    if (/already (been )?(completed|paid|processed)|has been (completed|paid)/.test(text)) return 'completed';
    return 'error';
}

export function paymentStateCopy(variant, overrides = {}) {
    const base = COPY[variant] || COPY.error;
    return { variant: COPY[variant] ? variant : 'error', title: overrides.title || base.title, message: overrides.message || base.message, hint: overrides.hint || base.hint };
}

export const RETRYABLE = new Set(['error']);
